import React, { useEffect, useState } from "react";
import { useController, Controller } from "react-hook-form";
import useIsFirstMount from "../../hooks/useIsFirstMount";


export const TextAreaField = React.forwardRef((props, ref) => {

    const { field, fieldState } = useController(props);
    const [focusState, setFocusState] = useState(false);
    const { title, isHighLight = false, style, type, errors, defaultValue, disabled = false, showTextLimit, ...others } = props;
    let err = _.get(errors, props.name);

    const isFirstMount = useIsFirstMount();

    useEffect(() => {
        if (!isFirstMount && defaultValue == '' && props?.call_from == 'pe') {
            field?.onChange((prev) => {e
                return ''
            }
            );
        }
    }, [defaultValue])


    return (
        <>
            <div ref={ref} className={`relative border border-gray ${style && 'bg-white'} focus-within:bg-white outlineStyle rounded ${props.rules && err ? "focus-within:border-red-600 border-red-600" : "focus-within:border-teal-c-900"}  ${disabled && "bg-gray-100"}`}>
                <Controller
                    name={props?.name}
                    control={props?.control}
                    rules={props?.rules}
                    defaultValue={defaultValue}
                    render={({ field }) => (
                        <textarea
                            {...props}
                            {...field}
                            onChange={(e) => {
                                field.onChange(e);
                                if (props.onChange) {
                                    props.onChange(e);
                                }
                            }}
                            style={style && style}
                            disabled={disabled ? disabled : false}
                            onBlurCapture={() => setFocusState(false)}
                            onFocus={() => setFocusState(true)}
                            rows={props.rows || 2}
                            value={field.value}
                            spellCheck="true"
                            autoComplete="off"
                            placeholder={props.placeholder ? props.placeholder : ''}
                            onBlur={(e) => {
                                if (props?.onBlur) {
                                    props.onBlur(e);
                                }
                            }}
                            className={`block p-2 w-full ${props.customHeight ? props.customHeight : ""} appearance-none focus:outline-none bg-white rounded focus:ring-0 text-base font-light text-black-300 ${disabled && "bg-gray-100"} ${props['data-audio-enabled'] ? 'recorder-icon' : ''} ${isHighLight && " bg-highLight  "}`} 
                        />
                    )}
                />

                <div
                    className={`pointer-events-none	 absolute ml-2.5  left-0  duration-300 origin-0  mr-2 inline-block px-1 font-normal 
                        ${props.rules && err ? "text-red-600" : "text-gray-600"}  ${focusState || !field.value == ""
                            ? "-top-2 duration-300 text-xs bg-white rounded-lg"
                            : "top-2.5 duration-300 text-base"
                        } ${disabled && "bg-gray-100"}
                        ${isHighLight && " bg-highLight  "}  
                        `

                    }
                >
                    {title} {props?.rules?.required?.value === true && <span className="text-red-500 mt-10">*</span>}
                </div>
                {showTextLimit && <div
                    className={`pointer-events-none	 absolute -top-4 text-xs -right-3 duration-300 origin-0  mr-2 inline-block px-1 font-normal text-black-300 `}
                >
                    ({props?.rules?.maxLength?.value - (field?.value?.length ? field?.value?.length : 0)} characters left)
                </div>}
            </div>


            {props.rules && err &&
                <p className="mt-0.5 text-xs text-red-600 h-3 text-left" id="email-error">
                    {props.rules && err && (
                        props.rules && err.message
                    )}
                </p>
            }
        </>
    );
});